import {
  withDatasourceCheck,
  Placeholder,
  NextImage,
  ImageField,
  LinkField,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import { useRef } from 'react';
import GlobalNavigation, {
  GlobalNavigationFields,
} from 'components/Generic/Header/GlobalNavigation/GlobalNavigation';
import ScLink from 'components/Generic/SitecoreWrappers/ScLink';
import { LanguageVersion } from 'model/LanguageVersion';
import { useSitecoreContext } from 'hooks/useSitecoreContext';

type HeaderProps = ComponentProps & {
  fields: {
    rendering: object;
    logo: ImageField;
    logoLink: LinkField;
    items: GlobalNavigationFields[];
  };
  languageVersions: LanguageVersion[];
  headerHeight: number;
};

const Header = (props: HeaderProps): JSX.Element => {
  const headerHeight = props.headerHeight;

  const haveBreadcrumbs: boolean = !!props.rendering.placeholders?.['abrdn-breadcrumbs']?.length;
  const showGlobalNavigation: boolean = props.fields.items.length > 0;
  const { sitecoreContext } = useSitecoreContext();
  const isExperienceEditor: boolean | undefined = sitecoreContext && sitecoreContext.pageEditing;
  const header = useRef(null);
  return (
    <header
      className={`abrdn-header position-relative ${haveBreadcrumbs && 'with-breadcrumbs'}`}
      style={{ minHeight: `${headerHeight}px` }}
    >
      <div id="headerContent" className={`${isExperienceEditor ? '' : 'fixed-top'}`} ref={header}>
        {showGlobalNavigation && (
          <GlobalNavigation
            data-e2e-component-uid={props.rendering.uid + '-global-nav'}
            globalNavFields={props.fields.items[0]}
          />
        )}
        <div className="background-white header-outer d-flex align-items-center">
          <div className="container">
            <div className="d-flex header-inner">
              <h5 className="me-auto font-weight-normal logo-wrapper align-self-center">
                <ScLink
                  field={props.fields.logoLink}
                  replaceWithSlot={true}
                  showExternalIcon={false}
                  className="logo-wrapper__link"
                >
                  <NextImage
                    field={props.fields.logo}
                    height="38"
                    width="110"
                    className="abrdn-logo"
                    alt="Aberdeen logo"
                  />
                </ScLink>
              </h5>
              <div className="header__content">
                <div className="d-flex w-100 align-items-center justify-content-end h-100">
                  <div className="h-100">
                    <Placeholder
                      className="h-100"
                      rendering={props.rendering}
                      name="abrdn-mega-navigation"
                      languageVersions={props.languageVersions}
                    />
                  </div>
                  <div>
                    <Placeholder
                      className="align-self-center"
                      rendering={props.rendering}
                      name="abrdn-language-selector"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="with-breadcrumbs w-100" style={{ top: `${headerHeight}px` }}>
        <Placeholder rendering={props.rendering} name="abrdn-breadcrumbs" />
      </div>
    </header>
  );
};

export default withDatasourceCheck()<HeaderProps>(Header);
